import { get, getWithoutTokenAndWithoutHeaders, post, urlApiTegra, del } from "../../../service/api";
import { serviceUsers } from "../../Collaborator/service";


const getSystemCost = (token: string) => {
  return get(`${urlApiTegra}/system_costs`, token);
};

const createClientGatewayPay = ({ token, body }: { token: string; body: any }) => {
  return post(`${urlApiTegra}/payments/clients`, body, token);
};

const getClientGatewayPay = ({ token }: { token: string }) => {
  return get(`${urlApiTegra}/payments/clients`, token);
};

const getIpClient = () => {
  return getWithoutTokenAndWithoutHeaders(`https://api.ipify.org?format=json`);
};

const createSubscriptionGatewayPay = ({ token, body }: { token: string; body: any }) => {
  return post(`${urlApiTegra}/payments/subscriptions`, body, token);
};

const getLastCharge = ({ token }: { token: string }) => {
  return get(`${urlApiTegra}/payments/charges`, token);
};

const getCancelSubscription = ({token}: {token: string}) => {
  return del(`${urlApiTegra}/payments/subscriptions`, token);
}

export { getSystemCost, createClientGatewayPay, getClientGatewayPay, getIpClient, createSubscriptionGatewayPay, getLastCharge, getCancelSubscription, valueByUser, getValuePlans, getUsersActiveThisMonth };


const valueByUser = async (plan, token): Promise<number> => {
  const planValue = await getValuePlans(plan, token);
  const usersActiveThisMonth = await getUsersActiveThisMonth(token);
  const { value } = planValue.find((item) => item.users > usersActiveThisMonth);
  return +value * usersActiveThisMonth;
};

const getValuePlans = async (plan, token) => {
  const res: IPlansValues[] = await getSystemCost(token);
  return res.map((item) => {
    const isYearPlan = plan === "Year";
    return {
      users: item.users,
      value: isYearPlan ? item.yearly : item.monthly,
    };
  });
};

const getUsersActiveThisMonth = async (token) => {
  const users = await serviceUsers.getUsers(token);
  const usersInactive = users.filter((item) => item.isDeleted);
  const usersInactiveThisMonth = usersInactive.filter((user) => {
    const currentYear = new Date().getFullYear();
    const yearIsEquals = currentYear === +user.end_date.slice(-4);
    const currentMonth = new Date().getMonth() + 1;
    const monthIsEquals = currentMonth === +user.end_date.slice(3, 5);

    return yearIsEquals && monthIsEquals ? user : null;
  });

  const usersActive = users.filter((item) => !item.isDeleted);
  const usersActiveThisMonth = [...usersActive, ...usersInactiveThisMonth];
  return usersActiveThisMonth?.length;
};


type IPlansValues = {
  id: number;
  users: number;
  monthly: string;
  yearly: string;
};